import { metricsConfig } from '../../config'
import { formatCurrency, formatRate } from '../../utils/formatters'
import { Ring } from '../shared/Ring'

export function PortfolioHealth() {
  const { portfolio_health: portfolioHealth } = metricsConfig

  const score = portfolioHealth.score
  const { mrr, churn_rate, arpu } = portfolioHealth.metrics
  const { previous_mrr, month_over_month, average_30d_arpu } = portfolioHealth.trend

  return (
    <section className="col-span-1 md:col-span-3 lg:col-span-1 h-full">
      <div className="h-full rounded-2xl border border-border bg-surface p-6 shadow-[0_12px_50px_rgba(8,13,24,0.6)]">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-base font-semibold text-ink">Portfolio Health</h3>
            <p className="text-xs text-muted">Read-only metrics snapshot</p>
          </div>
          <span className="px-2 py-0.5 rounded border border-border-light bg-surface-light text-[10px] uppercase tracking-wide text-muted">
            Synced
          </span>
        </div>
        <div className="mt-6 flex flex-col items-start gap-6 sm:flex-row sm:items-center">
          <div className="flex flex-col items-center">
            <Ring value={score} />
            <div className="mt-2 text-lg font-semibold text-ink">{score}/100</div>
            <div className="text-xs text-muted">Churn • ARPU • Growth</div>
          </div>
          <div className="grid flex-1 grid-cols-2 gap-x-6 gap-y-3 text-sm">
            <div className="text-muted">MRR</div>
            <div className="text-ink font-medium">{formatCurrency(mrr)}</div>

            <div className="text-muted">Churn</div>
            <div className="text-ink font-medium">{formatRate(churn_rate)}</div>

            <div className="text-muted">ARPU</div>
            <div className="text-ink font-medium">{formatCurrency(arpu)}</div>
          </div>
        </div>
        <div className="mt-6 grid gap-3 text-xs text-muted sm:grid-cols-3">
          <div className="rounded-lg border border-border-light bg-surface-light px-3 py-2">
            <div className="text-[11px] uppercase tracking-wide text-muted">Last MRR</div>
            <div className="text-ink font-medium">{formatCurrency(previous_mrr)}</div>
          </div>
          <div className="rounded-lg border border-border-light bg-surface-light px-3 py-2">
            <div className="text-[11px] uppercase tracking-wide text-muted">MoM Churn</div>
            <div className="text-ink font-medium">{formatRate(month_over_month)}</div>
          </div>
          <div className="rounded-lg border border-border-light bg-surface-light px-3 py-2">
            <div className="text-[11px] uppercase tracking-wide text-muted">30d Avg ARPU</div>
            <div className="text-ink font-medium">{formatCurrency(average_30d_arpu)}</div>
          </div>
        </div>
      </div>
    </section>
  )
}
